import React from 'react';
import { Loader } from '@naf-simba/building-blocks-loaders';
import { SpinnerWrapper } from './Styles';

export const Spinner = () => (
  <SpinnerWrapper>
    <Loader />
  </SpinnerWrapper>
);
